import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { TermsAcceptanceModal } from '@/components/terms-acceptance-modal/terms-acceptance-modal';
import { BASE_PATH } from '@/constants/config';
import { getSafeReturnTo } from '@/utils/get-safe-return-to';
import { hasAcceptedCurrentTerms, TermsAudience } from '@common/utils';

export const Route = createFileRoute('/researchers/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    const { user } = context;

    if (!user) {
      // Only worth attaching now that `/researchers/login` is a stub that
      // forwards its search into `/login`, which resumes it. Before this PR
      // the param was read by nobody and dropped again by the dev gate.
      const returnTo = getSafeReturnTo(
        `${BASE_PATH}${location.pathname}${location.searchStr}`,
      );
      throw redirect({
        to: '/researchers/login',
        ...(returnTo ? { search: { returnTo } } : {}),
      });
    }

    if (!user.roles.includes('researcher')) {
      throw redirect({ to: '/participants' });
    }

    return { user };
  },
  component: AuthenticatedResearcherLayout,
});

function AuthenticatedResearcherLayout() {
  const { user, isAdminImpersonating } = Route.useRouteContext();
  const requiresTermsAcceptance =
    !isAdminImpersonating &&
    !hasAcceptedCurrentTerms(user.termsAcceptance, TermsAudience.RESEARCHER);

  return (
    <>
      {requiresTermsAcceptance && (
        <TermsAcceptanceModal
          audience={TermsAudience.RESEARCHER}
          userId={user.id}
        />
      )}
      <Outlet />
    </>
  );
}
